import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../store/useAuth";
import { ComponentType } from "react";
import { Container, Menu, Navbar } from "../../layouts";

// Define a higher-order component function
export const withProtectedRoute = (WrappedComponent: ComponentType<any>) => {
  // This function returns a new component
  return function WithProtectedRoute(props: JSX.IntrinsicAttributes) {
    const { isAuthenticated, user } = useAuth();
    const location = useLocation();
    const plasticOnlyPaths = [
      "/plastic-dashboard/conversion",
      "/plastic-dashboard/volumes",
    ];

    if (!isAuthenticated) return <Navigate to="/login" />;
    if (
      user?.user_role === 6 &&
      !plasticOnlyPaths.includes(location.pathname)
    ) {
      return <Navigate to="/plastic-dashboard/conversion" replace />;
    }
    return (
      <div className="flex min-h-screen bg-slate-50">
        <Menu />
        <div className="flex-1 flex flex-col w-full sm:pl-72">
          <Navbar />
          <div className="flex-1 pt-20">
            <Container>
              <WrappedComponent {...props} />
            </Container>
          </div>
        </div>
      </div>
    );
  };
};
